import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const OurOfferingAiStrategy = () => {
    return (
        <div className="section-py !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our AI Strategy & Consulting Offerings
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-agent-design.svg" width={36} height={36} alt="AI maturity assessment" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">AI maturity assessment & organizational readiness evaluation frameworks</p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-server.svg" width={36} height={36} alt="Business opportunity" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Business opportunity analysis identifying high-ROI AI use cases
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-multi-agent.svg"
                                width={36}
                                height={36}
                                alt="AI strategy development"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            AI strategy development with 12-36 months roadmaps & milestones
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-action-validation.svg"
                                width={36}
                                height={36}
                                alt="Technology stack evaluation"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Technology stack evaluation, vendor selection & build-vs-buy recommendations
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-secure-audit.svg"
                                width={36}
                                height={36}
                                alt="Proof-of-concept design"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Proof-of-concept design, scoping & rapid validation (4-8 weeks)
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-[50px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-monitoring.svg"
                                width={36}
                                height={36}
                                alt="Data readiness assessment"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data readiness assessment, architecture review & governance planning
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-agent-accelerators.svg"
                                width={36}
                                height={36}
                                alt="ROI modeling"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            ROI modeling, business case development & executive presentation materials
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="AI operating model" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           AI operating model design, including roles, governance & workflows
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-custom-data-indexing.svg"
                                width={36}
                                height={36}
                                alt="Change management planning"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Change management planning, stakeholder alignment & risk assessment
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-hybrid-rpa-ai.svg" width={36} height={36} alt="Competitive intelligence" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Competitive intelligence on AI adoption trends & industry benchmarks
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-ready-transform rounded-10 relative">
                    <div className="counter-overlay"></div>
                    <div className="lg:col-span-12 lg:p-12 md:p-5 p-5 relative z-[1]">
                        <h2 className="mb-3 text-white">Ready to Transform Your Enterprise Knowledge into Intelligent Action?</h2>
                        <p className="mb-3 text-white">
                            Request a demo to see production-ready RAG pipelines and enterprise chatbots in action
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurOfferingAiStrategy;
